export const eventData = {
  strapiWidgetCtaClick: 'strapi_widget_cta_click',
}

export const eventMapping = {
  [eventData.strapiWidgetCtaClick]: {
    event: eventData.strapiWidgetCtaClick,
  },
}
